import type { OrganizationListResponseApi } from '@ingenico/api-sdk-provisioning-public';
import { toString } from 'lodash-es';
import type {
  ProvisioningOrganizationListResponse,
  ProvisioningOrganizationResource,
  ProvisioningOrganizationLocation,
  ProvisioningOrganizationHelpdeskInfo,
  ProvisioningOrganizationParent,
  EnumActivityType,
  EnumProvisioningEntityType,
} from '../../../models/organization.model';

function mapLocation(location?: {
  address?: string;
  city?: string;
  country?: string;
  state?: string;
  zipCode?: string;
}): ProvisioningOrganizationLocation | undefined {
  if (!location) return undefined;
  return {
    address: location.address,
    city: location.city,
    country: location.country,
    state: location.state,
    zipCode: location.zipCode,
  };
}

function mapHelpdeskInfo(helpdeskInfo?: { phoneNumber?: string }): ProvisioningOrganizationHelpdeskInfo | undefined {
  if (!helpdeskInfo) return undefined;
  return {
    phoneNumber: helpdeskInfo.phoneNumber,
  };
}

function mapParent(parent?: { id: string; type: string }): ProvisioningOrganizationParent | undefined {
  if (!parent) return undefined;
  return {
    id: toString(parent.id),
    type: parent.type as EnumProvisioningEntityType,
  };
}

function mapOrganizationResource(org: OrganizationListResponseApi['data'][number]): ProvisioningOrganizationResource {
  return {
    id: toString(org.id),
    name: toString(org.name),
    reference: org.reference,
    activityType: org.activityType as EnumActivityType | undefined,
    helpdeskInformation: mapHelpdeskInfo(org.helpdeskInformation),
    location: mapLocation(org.location),
    parent: mapParent(org.parent),
  };
}

export function mapProvisioningOrganizationsList(
  response: OrganizationListResponseApi,
): ProvisioningOrganizationListResponse {
  return {
    data: response.data.map(mapOrganizationResource),
    pagination: {
      itemsPerPage: response.pagination.itemsPerPage,
      startIndex: response.pagination.startIndex,
      totalResults: response.pagination.totalResults,
    },
  };
}
